export default "__VITE_ASSET__ChYoNey7__"